import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'equine-ui-nx-onboard-error-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    MatButtonModule
  ],
  templateUrl: './onboard-error-dialog.component.html',
  styleUrl: './onboard-error-dialog.component.scss',
})
export class OnboardErrorDialogComponent {

  data = inject(MAT_DIALOG_DATA);

}
